const guaranty = {
    getlist: 'guaranty/getlist',
    add: 'guaranty/add',
    update: 'guaranty/update',
    remove: 'guaranty/remove',
    get: 'guaranty/get',
    getall: 'guaranty/getall',
    clearcache: 'guaranty/clear-cache',
}
export default guaranty
